import { environment } from '../../../../environments/environment';
import { isUrlExcludedFromJwtTokenRefresh } from '../is-refresh-retry-blacklisted-url/is-url-excluded-from-jwt-token-refresh.helper';

const getHost = (url: string): string | undefined => {
  try {
    return new URL(url, globalThis.location.origin).host;
  } catch {
    return undefined;
  }
};

export const isAuthEligibleRequest = (url: string): boolean => {
  const requestHost = getHost(url);

  return (
    requestHost !== undefined &&
    environment.allowedDomains.includes(requestHost) &&
    !isUrlExcludedFromJwtTokenRefresh(url)
  );
};
